import {
  BUILD_TOOLS,
  BUILD_TOOLS_SUCCESS,
  BUILD_TOOLS_FAILURE,
  RESET_NAVIGATION_STATE,
} from './actionTypes';

export const redirectBuildTools = (accessToken, accelType) => ({
  type: BUILD_TOOLS,
  accessToken,
  accelType,
});

export const redirectBuildToolsSuccess = () => ({
  type: BUILD_TOOLS_SUCCESS,
});

export const redirectBuildToolsFailure = () => ({
  type: BUILD_TOOLS_FAILURE,
});

export const resetNavigationState = () => ({
  type: RESET_NAVIGATION_STATE,
});
